// src/components/PrivateRoute.jsx
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const expiry = localStorage.getItem('token_expiry'); // expiry timestamp (ms)

  const isExpired = () => {
    if (!expiry) return true;
    return Date.now() > parseInt(expiry);
  };

  if (!token || isExpired()) {
    // clear storage if expired
    localStorage.removeItem('token');
    localStorage.removeItem('token_expiry');
    return <Navigate to="/" />;
  }

  return children;
};

export default PrivateRoute;


